import cities from '../data/cities';

class GuestSessionService {
  constructor() {
    this.sessionKey = 'zonewise_guest_session';
    // Pre-rename key; existing guest sessions migrate on first read
    this.legacySessionKey = 'timehopper_guest_session';
    this.defaultCities = [
      'New York, NY',
      'London, United Kingdom', 
      'Nairobi, Kenya',
      'Bangalore, India',
      'Melbourne, Australia'
    ];
  }

  // Initialize session with default cities if empty
  initializeSession() {
    const existing = this.getSession();
    if (!existing || !existing.selectedTimezones || existing.selectedTimezones.length === 0) {
      const defaultTimezones = this.defaultCities
        .map(cityName => cities.find(c => c.name === cityName))
        .filter(Boolean);
      
      this.saveSession({
        selectedTimezones: defaultTimezones
      });
      
      return defaultTimezones;
    }
    return existing.selectedTimezones;
  }

  // Get current session data
  getSession() {
    try {
      const stored = sessionStorage.getItem(this.sessionKey);
      if (stored) {
        return JSON.parse(stored);
      }
      return this.migrateLegacySession();
    } catch (error) {
      console.error('Error reading guest session:', error);
    }
    return null;
  }

  // Move a session stored under the old timehopper key to the new key
  migrateLegacySession() {
    try {
      const stored = sessionStorage.getItem(this.legacySessionKey);
      if (stored) {
        const data = JSON.parse(stored);
        sessionStorage.setItem(this.sessionKey, stored);
        sessionStorage.removeItem(this.legacySessionKey);
        return data;
      }
    } catch (error) {
      console.error('Error migrating legacy guest session:', error);
    }
    return null;
  }

  // Save session data
  saveSession(data) {
    try {
      sessionStorage.setItem(this.sessionKey, JSON.stringify(data));
    } catch (error) {
      console.error('Error saving guest session:', error);
    }
  }

  // Get selected timezones
  getSelectedTimezones() {
    const session = this.getSession();
    if (session && session.selectedTimezones) {
      return session.selectedTimezones;
    }
    return this.initializeSession();
  }

  // Add timezone
  addTimezone(city) {
    const timezones = this.getSelectedTimezones();
    
    // Check if city already exists
    if (!timezones.find(tz => tz.name === city.name)) {
      timezones.push(city);
      this.saveSession({ selectedTimezones: timezones });
    }
    
    return timezones;
  }

  // Remove timezone
  removeTimezone(cityName) {
    const timezones = this.getSelectedTimezones();
    const filtered = timezones.filter(tz => tz.name !== cityName);
    
    this.saveSession({ selectedTimezones: filtered });
    return filtered;
  }

  // Reorder timezones
  reorderTimezones(newOrder) {
    this.saveSession({ selectedTimezones: newOrder });
    return newOrder;
  }

  // Clear session (useful for testing)
  clearSession() {
    try {
      sessionStorage.removeItem(this.sessionKey);
      sessionStorage.removeItem(this.legacySessionKey);
    } catch (error) {
      console.error('Error clearing guest session:', error);
    }
  }
}

export const guestSessionService = new GuestSessionService();
export default guestSessionService;